/** PortalOffice公開フラグ */
export const PORTAL_OFFICE_IS_PUBLIC = [
  { text: "公開", value: true },
  { text: "非公開", value: false },
];

export const PORTAL_OFFICE_IS_PUBLIC_COLOR = [
  { text: "blue", value: true },
  { text: "grey", value: false },
];

/** PortalOffice審査ステータス */
export const PORTAL_OFFICE_APPROVAL_STATUS = [
  { text: "未処理", value: 0 },
  { text: "処理中", value: 1 },
  { text: "承認済み", value: 2 },
  { text: "差し戻し", value: 3 },
  { text: "却下", value: 4 },
];

export const PORTAL_OFFICE_APPROVAL_STATUS_COLOR = [
  { text: "red", value: 0 },
  { text: "pink", value: 1 },
  { text: "blue", value: 2 },
  { text: "amber", value: 3 },
  { text: "brown", value: 4 },
];

/** PortalOffice 2サービス目の参加申請（保留中のサービス）。0=保留なし */
export const PORTAL_OFFICE_PENDING_JOIN_SERVICE = [
  { text: "けあログっと", value: 1 },
  { text: "カエドキ", value: 2 },
];

/** PortalOffice 1サービス目として承認するサービス（primary_service_type） */
export const PORTAL_OFFICE_PRIMARY_SERVICE_TYPE = [
  { text: "けあログっと", value: 1 },
  { text: "カエドキ", value: 2 },
];

/** PortalOffice掲載情報初回審査ステータス */
export const PORTAL_OFFICE_LISTING_REVIEW_STATUS = [
  { text: "準備中", value: 0 },
  { text: "掲載承認待ち", value: 1 },
  { text: "審査完了", value: 2 },
  { text: "差し戻し", value: 3 },
];

export const PORTAL_OFFICE_LISTING_REVIEW_STATUS_COLOR = [
  { text: "grey", value: 0 },
  { text: "pink", value: 1 },
  { text: "blue", value: 2 },
  { text: "brown", value: 3 },
];

/** PortalOfficeお知らせ配信先区分 */
export const PORTAL_OFFICIAL_ANNOUNCEMENT_DESTINATION = [
  { text: "紹介側", value: 1 },
  { text: "掲載側", value: 2 },
  { text: "紹介側・掲載側", value: 3 },
  { text: "未ログイン", value: 4 },
  { text: "全体", value: 5 },
];

export const PORTAL_JOBSEARCH_OFFICIAL_ANNOUNCEMENT_DESTINATION = [
  { text: "応募側", value: 6 },
  { text: "掲載側", value: 7 },
  { text: "応募側・掲載側", value: 8 },
  { text: "未ログイン", value: 9 },
  { text: "全体", value: 10 },
];

/** PortalOfficeお知らせステータス */
export const PORTAL_OFFICIAL_ANNOUNCEMENT_STATUS = [
  { text: "下書き", value: 1 },
  { text: "配信予約済み", value: 2 },
  { text: "配信済み", value: 3 },
];

export const PORTAL_OFFICIAL_ANNOUNCEMENT_STATUS_COLOR = [
  { text: "blue-grey-lighten-4", value: 1 },
  { text: "pink", value: 2 },
  { text: "light-blue", value: 3 },
];

/** PortalStaff権限 */
export const PORTAL_STAFF_ROLE = [
  { text: "管理", value: 1 },
  { text: "一般", value: 2 },
];

/** 応募 選考ステータス */
export const PORTAL_JOBSEARCH_APPLICATION_SELECTION_STATUS = [
  { text: "未対応", value: 0 },
  { text: "書類選考中", value: 1 },
  { text: "カジュアル面談", value: 2 },
  { text: "一次面接", value: 3 },
  { text: "二次面接", value: 4 },
  { text: "三次面接", value: 5 },
  { text: "最終面接", value: 6 },
  { text: "内定", value: 7 },
  { text: "お見送り", value: 8 },
  { text: "内定受諾", value: 9 },
  { text: "内定辞退", value: 10 },
];

/** 職務経歴書 雇用タイプ */
export const PORTAL_JOBSEARCH_RECRUITEE_WORK_EMPLOYMENT_TYPE = [
  { text: "正社員", value: 1 },
  { text: "契約社員", value: 2 },
  { text: "パート・アルバイト", value: 3 },
  { text: "業務委託", value: 4 },
];

/** 口コミ公開フラグ */
export const PORTAL_OFFICE_REVIEW_IS_OPEN = [
  { text: "公開", value: true },
  { text: "非公開", value: false },
];

/** 口コミ承認ステータス */
export const PORTAL_OFFICE_REVIEW_APPROVAL_STATUS = [
  { text: "未承認", value: 0 },
  { text: "承認", value: 1 },
  { text: "棄却", value: 2 },
];

export const PORTAL_OFFICE_REVIEW_ASPECT_TYPE_LABEL = [
  { text: "仕事内容はどうだったか", value: 1 },
  { text: "職場の環境・雰囲気", value: 2 },
  { text: "同僚・上司との関係性", value: 3 },
  { text: "安心宣言どおりだったか", value: 4 },
];

export const PORTAL_JOBSEARCH_LISTING_OCCUPATION = [
  { text: "指定なし", value: 1 },
  { text: "看護師", value: 2 },
  { text: "准看護師", value: 3 },
  { text: "認定看護師", value: 4 },
  { text: "助産師", value: 5 },
  { text: "保健師", value: 6 },
  { text: "管理職", value: 7 },
  { text: "理学療法士（PT）", value: 8 },
  { text: "作業療法士（OT）", value: 9 },
  { text: "言語聴覚士（ST）", value: 10 },
  { text: "精神保健福祉", value: 11 },
];

export const PORTAL_JOBSEARCH_BUSINESS_DOMAIN = [
  { text: "診療所・クリニック", value: 1 },
  { text: "介護施設", value: 2 },
  { text: "訪問看護ステーション", value: 3 },
  { text: "精神科特化型訪問看護ステーション", value: 4 },
  { text: "機能強化型訪問看護ステーション", value: 5 },
  { text: "慢性期・療養型病院", value: 6 },
  { text: "急性期病棟", value: 7 },
  { text: "回復期病棟", value: 8 },
  { text: "障害者支援", value: 9 },
  { text: "一般病院", value: 10 },
  { text: "保育所（保育園）", value: 11 },
  { text: "訪問入浴介助", value: 12 },
  { text: "放課後等デイサービス", value: 13 },
  { text: "企業", value: 14 },
];
